module.exports = __webpack_public_path__ + "img/wordOne.c848c1a2.png";